module.exports = __webpack_public_path__ + "assets/profile3.499bdc77.svg";